import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/shared/theme/fonts/googleSansFlex.css';
import './index.css';
import '@/shared/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

